<template>
  <div class="page-cards">
    <el-row :gutter="15" justify="space-between">
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
        v-if="ActiveOrInactive == 1 || ActiveOrInactive == null"
      >
        <card-total
          text="Activos"
          icon="el-icon-circle-check success-text"
          :count="activeProspect"
          :total="activeProspect"
          :loading.sync="loading"
        />
      </el-col>
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
        v-if="ActiveOrInactive == 2 || ActiveOrInactive == null"
      >
        <card-total
          text="Inactivos"
          icon="el-icon-circle-close danger-text"
          :count="InactiveProspect"
          :total="InactiveProspect"
          :loading.sync="loading"
        />
      </el-col>
    </el-row>
    <rabbey-toolbox
      :call-new="callNew"
      :filterables="true"
      :buttons-views="listView"
      @change-view="onChangeView"
      @filter-search="onFilterSearch"
    >
      <div class="box mr-5">
        <SellerSelector
          v-if="
            IsInRoles([
              roles.SupervisorDeVentas,
              roles.SupervisorDeSoporteDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ])
          "
          v-model="seller_filter"
          @change="handleChangeSeller"
        />
      </div>
      <br />
      <!-- Filtro de prospectos Activos e Inactivos -->
      <el-select
        size="mini"
        v-model="ActiveOrInactive"
        placeholder="Select"
        filterable
        clearable
      >
        <el-option
          v-for="item in ListActiveOrInactive"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </rabbey-toolbox>
    <el-row>
      <el-col>
        <transition name="slide-fade" mode="out-in">
          <component
            v-bind:is="currentTabComponent"
            :items="items"
            :actions="actions"
            :search="search"
            :seller_filter="seller_filter"
            :filterList="filterList"
            :module="module"
            :loading.sync="loading"
            :paginationApi="{
              currentPage: currentPage,
              pageSize: limit,
              total: totalItems,
              pageSizes: pageSizes
            }"
            @card-click-action="handleCommand('cards', $event)"
            @rtable-push-action="handleCommand('table', $event)"
            @update-page-size="handleSizeChange"
            @update-current-page="handleCurrentChange"
            @v-on:update-prospects="this.fetchProspects()"
          ></component>
        </transition>
      </el-col>
    </el-row>

    <!-- <dialog-new-interaction-form
      :CustomerData="CustomerData"
      ref="dialogNewInteraction"
    /> -->
    <dialog-new-request-form ref="dialogNewRequest" />
    <prospect-detail
      ref="details"
      :ProspectData="data"
      :drawer.sync="drawerDetail"
      :isEditingModel="isEditingModel"
      @update-data="handleUpdateData"
      @closeDrawer="handleCloseDrawer"
    />
    <deals-form-drawer
      ref="drawerNewDeal"
      :drawer.sync="drawerDeal"
      v-bind="dealBind"
      @close-drawer="handleDealCloseDrawer"
    />
    <contact-from ref="contact" :drawer.sync="drawerContact" />
    <ObjectiveTasksDialog
      :ActualObjective="ActualObjective"
      :columnTaskCodeFrom="columnTaskCodeFrom"
      :PropectId="PropectId"
      :ObjectiveTasksDialogVisibility="ObjectiveTasksDialogVisibility"
      :IsInCharged="IsInCharged"
      @ObjectiveTasksDialogClosing="ObjectiveTasksDialogClosing"
    />
  </div>
</template>

<script>
import DealsFormDrawer from "@/components/deals/DealsFormDrawer";
import Deal from "@/models/deals/Deal";
import ContactFrom from "@/components/contacts/ContactForm";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import { mapGetters, mapActions } from "vuex";
import CardTotal from "@/components/CardTotalOriginal.vue";
import ObjectiveTasksDialog from "@/components/cmi/ObjectivesReport/ObjectiveTasksDialog";

export default {
  name: "ProspectList",
  props: {
    module: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      activeProspect: null,
      InactiveProspect: null,
      ListActiveOrInactive: [
        {
          label: "Activos",
          value: 1
        },
        {
          label: "Inactivos",
          value: 2
        },
        {
          label: "Todos",
          value: null
        }
      ],
      page: 1,
      limit: 10,
      totalItems: 0,
      isEditingModel: "false",
      pageSizes: [100, 500, 1000],
      CustomerData: {},
      dealBind: {
        fromAction: true,
        isProspect: true,
        isClient: false
      },
      pageSize: 100,
      currentPage: 1,
      search: "",
      filterList: [],
      items: [],
      loading: false,
      drawerContact: false,
      drawerDeal: false,
      drawerDetail: false,
      seller_filter: "",
      ActiveOrInactive: null,
      paramsFilter: {
        salesPersonCode: undefined,
        SellerId: null,
        Search: null
      },
      data: {
        SalesPersonCode: this.$store.state.user.user.SalesPersonCode,
        SalesPersonName: this.$store.state.user.user.SalesPersonName,
        MagycorpCompanyId: this.$store.state.user.user.CompanySelected,
        CompanyName: "",
        VatRegistrationNumber: "",
        Address: "",
        AddressTwo: "",
        City: "",
        FirstName: "",
        MiddleName: "",
        SurName: "",
        JobTitle: "",
        PhoneNumber: "",
        ExtensionNumber: "",
        MobilePhoneNumber: "",
        Email: "",
        Number: "",
        PictureDirectory: "",
        Birthday: "2020-08-13T15:54:09.551Z",
        Name: ""
      },
      NegotiationId: 0,
      ObjectiveTasksDialogVisibility: false,
      ActualObjective: {},
      columnTaskCodeFrom: "",
      IsInCharged: false,
      currentTabComponent: () =>
        import("@/components/prospects/ProspectCards.vue"),
      listView: [
        {
          icon: "el-icon-s-grid",

          component: () =>
            import(
              /* webpackChunkName: "ProspectCards" */ "@/components/prospects/ProspectCards.vue"
            )
        },
        {
          icon: "mdi mdi-table-of-contents",
          component: () =>
            import(
              /* webpackChunkName: "ProspectTable" */ "@/components/prospects/ProspectTable.vue"
            )
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "view2"
        },
        {
          icon: "el-icon-plus",
          label: "Nueva Negociacion",
          command: "new_deal"
        },
        // {
        //   icon: "el-icon-plus",
        //   label: "Nueva Interacción",
        //   command: "new_interaction"
        // },
        {
          icon: "el-icon-plus",
          label: "Nueva Solicitud",
          command: "new_request"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar Prospectos",
          command: "inact"
        },
        {
          icon: "el-icon-view",
          label: "Ver Tareas",
          command: "view_task"
        }
      ]
    };
  },
  components: {
    CardTotal,
    "dialog-new-interaction-form": () =>
      import(
        /* webpackChunkName: "DialogNewInteractionForm" */ "@/components/interactions/DialogNewInteractionForm.vue"
      ),
    "prospect-detail": () =>
      import(
        /* webpackChunkName: "ProspectDetails" */ "@/components/prospects/ProspectDetails.vue"
      ),
    "dialog-new-request-form": () =>
      import(
        /* webpackChunkName: "NewRequestProspect" */ "@/components/requests/NewRequestProspect.vue"
      ),
    DealsFormDrawer,
    ContactFrom,
    SellerSelector,
    ObjectiveTasksDialog
  },
  async created() {
    this.fetchProspects();
    this.fetchProspectsActiveOrInactive();

    if (this.$store.state.interactions.list.length <= 0) {
      this.$store.dispatch("interactions/all");
    }

    if (this.$store.state.interactions.list_interaction_code.length <= 0) {
      this.$store.dispatch("interactions/get_interaction_code");
    }

    if (this.$store.state.products.list.length <= 0) {
      this.$store.dispatch("products/all");
    }

    if (this.$store.state.request_types.list.length <= 0) {
      this.$store.dispatch("request_types/all");
    }

    if (this.$store.state.request_types.list.length <= 0) {
      this.$store.dispatch("request_types/all");
    }
    // this.getProspectList();
    await this.IsHeinCharged().then((resp) => {
      this.IsInCharged = resp;
    });
  },
  methods: {
    ...mapActions("prospects", ["getProspects", "searchProspects"]),
    async fetchProspectsActiveOrInactive(options) {
      if (!options) {
        options = {};
      }
      this.loading = true;
      this.$http
        .get("/api/prospects", {
          params: {
            ...this.paramsActiveOrInactive,
            ...options
          }
        })
        .then((response) => {
          const {
            data: { Items }
          } = response;

          this.activeProspect = Items.filter(
            (item) => item.status_procpects == 1
          ).length;
          this.InactiveProspect = Items.filter(
            (item) => item.status_procpects == 2
          ).length;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchProspects(options) {
      if (!options) {
        options = {};
      }
      this.loading = true;
      this.$http
        .get("/api/prospects", {
          params: {
            ...this.params,
            ...options
          }
        })
        .then((response) => {
          const {
            data: { Items, CurrentPage }
          } = response;

          this.items = Items;
          this.currentPage = CurrentPage;
          this.totalItems = Items.length;
          this.activeProspect = Items.filter(
            (item) => item.status_procpects == 1
          ).length;
          this.InactiveProspect = Items.filter(
            (item) => item.status_procpects == 2
          ).length;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },
    onChangeView(component) {
      this.currentTabComponent = component;
    },
    callNew() {
      if (this.module === "sales") {
        this.$router.push({ name: "sales-prospects-create" });
      } else if (this.module === "call-center") {
        this.$router.push({ name: "call-center-prospects-create" });
      }
    },
    onFilterSearch(s) {
      this.search = s;
      this.fetchProspects({ Search: s });
    },
    handleChangeSeller(seller) {
      this.paramsFilter.SellerId = seller;
      this.fetchProspects({ SellerId: seller });
    },
    async handleCommand(type, c) {
      let row;
      if (type === "cards") {
        row = c.data;
        this.CustomerData = row;
      } else if (type === "table") {
        row = c.row;
        this.CustomerData = row;
      } else {
        return false;
      }

      switch (c.command) {
        case "view": {
          this.data = row;
          this.drawerDetail = true;
          this.isEditingModel = "false";

          break;
        }

        case "view2": {
          this.isEditingModel = "true";
          this.data = row;
          this.drawerDetail = true;
          break;
        }

        case "new_deal": {
          Deal.CustomerCode = row.ContactCode;
          this.dealBind.code = row.ContactCode;
          this.dealBind.initModel = {
            CustomerServiceId: row.CustomerServiceEmployerId,
            SellerId: row.SellerId,
            CurrencyID: 3
          };

          this.drawerDeal = true;
          this.$refs.drawerNewDeal.setValueDefault("new_deal", row);
          break;
        }

        // case "new_interaction": {
        //   this.$refs.dialogNewInteraction.show(row.ContactCode, true);
        //   break;
        // }

        case "new_request": {
          this.$refs.dialogNewRequest.show(row.ContactCode, row);
          break;
        }

        case "new_contact": {
          this.drawerContact = true;
          this.$refs.contact.model.CustomerCode = row.ContactCode;
          break;
        }

        case "inact": {
          this.DeleteProspect(row.Id);
          break;
        }

        case "view_task": {
          this.ActualObjective = {
            ObjectiveCombinedId: "Obj-3204",
            ObjectiveShortDescription: "Tareas de Prospectos",
            PerpectiveID: 2,
            ObjectiveId: 3204,
            DateInit: "2025-07-22",
            DateEnd: "2099-12-31"
          };
          this.columnTaskCodeFrom = "TT";
          this.PropectId = row.Id;
          //this.isInCharged = await this.IsHeinCharged();
          this.ObjectiveTasksDialogVisibility = true;
          break;
        }

        default:
          break;
      }
    },
    DeleteProspect(id) {
      this.$confirm("¿Segura/o que desea eliminar el Prospecto?")
        .then(() => {
          this.$http
            .put(`/api/prospects/DisabledFromSystems?id=${id}`)
            .then(() => {
              this.$message({
                type: "success",
                message: "Prospecto Eliminado"
              });
              let deletedProspect = this.items.findIndex((c) => c.Id == id);
              this.items.splice(deletedProspect, 1);
            })
            .catch(() => {
              this.message.error("Error al eliminar el prospecto");
            })
            .finally(() => {
              this.drawerDeal = false;
            });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchProspects({ Limit: val });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchProspects({ Page: val });
    },
    handleUpdateData(data) {
      const index = this.items.findIndex((f) => f.Id === data.Id);
      if (index > -1) {
        this.items.splice(index, 1, data);
      }
    },
    handleCloseDrawer() {
      this.drawerDetail = false;
      this.data = {
        SalesPersonCode: this.$store.state.user.user.SalesPersonCode,
        SalesPersonName: this.$store.state.user.user.SalesPersonName,
        MagycorpCompanyId: this.$store.state.user.user.CompanySelected,
        CompanyName: "",
        VatRegistrationNumber: "",
        Address: "",
        AddressTwo: "",
        City: "",
        FirstName: "",
        MiddleName: "",
        SurName: "",
        JobTitle: "",
        PhoneNumber: "",
        ExtensionNumber: "",
        MobilePhoneNumber: "",
        Email: "",
        Number: "",
        PictureDirectory: "",
        Birthday: "2020-08-13T15:54:09.551Z",
        Name: ""
      };
    },
    handleDealCloseDrawer() {
      this.drawerDeal = false;
    },
    ObjectiveTasksDialogClosing() {
      this.ObjectiveTasksDialogVisibility = false;
    },
    async IsHeinCharged() {
      let IsHeinChargedPromise = await new Promise((resolve, reject) => {
        this.loadingData = true;
        const parameters = {
          params: {
            employee: this.currentUser.EmployeeId
          }
        };
        this.$http
          .get("/api/departments/IsHeIncharged", parameters)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            this.$message.error(err);
            reject(err);
          });
      });
      return IsHeinChargedPromise;
    }
  },
  computed: {
    ...mapGetters({ list_vendors: "sellers/list_to_select" }),
    getProspect() {
      return this.prospect[this.currentCompany];
    },
    params() {
      return {
        UserId: this.currentUser.UserID,
        userName: this.currentUser.UserName,
        companyId: this.currentCompany,
        salesPersonCode: this.currentUser.PersonCode,
        SalesPersonName: this.currentUser.SalesPersonName,
        Page: this.currentPage,
        Limit: this.pageSize,
        Search: this.search,
        SellerId: this.seller_filter,
        status_procpects: this.ActiveOrInactive
      };
    },
    paramsActiveOrInactive() {
      return {
        UserId: this.currentUser.UserID,
        userName: this.currentUser.UserName,
        companyId: this.currentCompany,
        salesPersonCode: this.currentUser.PersonCode,
        SalesPersonName: this.currentUser.SalesPersonName,
        Page: this.currentPage,
        Limit: 100000,
        Search: this.search,
        SellerId: this.seller_filter,
        status_procpects: this.ActiveOrInactive
      };
    }
  },
  watch: {
    ActiveOrInactive() {
      this.fetchProspects();
    }
  }
};
</script>
